import React, { useContext, useEffect, useState } from 'react'

import { firestore } from '../../../firebase';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

import StateContext from '../../../StateContext';
import ImageGrid from '../Media/ImageGrid';

function AddPost() {

    const appState = useContext(StateContext)

    const [title, setTitle] = useState("");
    const [image, setImage] = useState("");
    const [authorName, setAuthorName] = useState("");
    const [content, setContent] = useState("");
    const [date, setDate] = useState("");

    const [showImage, setShowImage] = useState(false)
    const [message, setMessage] = useState("")

    function toggleImageGrid() {
        if (showImage) {
            setShowImage(false);
        } else {
            setShowImage(true)
        }

    }

    async function addPostHandler(e) {
        e.preventDefault();
        try {
            const postRef = firestore.collection("football-blogs");
            const date_iso = new Date().toISOString()
            const postData = {
                title, 
                content,
                image,
                author_name: authorName,
                date,
                date_iso,
                featured_image_post: image
            }
            postRef.add(postData)
            setMessage("Innlegg lagt til!")
        } catch (error) {
            setMessage(error.message)
        }
    }


    if (!appState.loggedIn) return <p>Logg inn for å legg til innlegg</p>

    return (
        <div className="container my-4">

            <form onSubmit={addPostHandler}>
                <input placeholder="Tittel" className="form-control  mb-2" value={title} onChange={e => setTitle(e.target.value)} />

                <label>Dato</label>
                <input type="date" className="form-control mb-2" value={date} onChange={e => setDate(e.target.value)} />

                <label>Forfatter</label>
                <input className="form-control mb-2" value={authorName} onChange={e => setAuthorName(e.target.value)} />

                <div style={{cursor: "pointer"}} className="btn btn-success" onClick={toggleImageGrid} >Velg fremhevet bilde</div>
                {showImage && <ImageGrid selectedImg={image} setSelectedImg={setImage} setShowImage={setShowImage} /> }

                <div>
                    <label>Fremhevet bilde</label>
                    <img src={image} className="img-fluid" />
                </div>

                <label>Innhold</label>
                <ReactQuill theme="snow" value={content} onChange={setContent} />

                {message && <div className="alert alert-success">{message}</div>}
                <button className="btn btn-primary">Lagre innlegg</button>

            </form>

        </div>
    )
}
export default AddPost